import IndividuationService from "@/axios";
import {Message} from "element-ui";

const qs = require("qs");
const object = require("lodash/fp/object");
const privateService = {
    options: {
        timeout: 50 * 1000
    },
    interceptors(service) {
        service.interceptors.request.use(
            config => {
                if (!config.headers.type) {
                    config.data = qs.stringify(config.data);
                }
                return config;
            },
            error => {
                return Promise.reject(error);
            }
        );

        // 返回数据拦截操作
        service.interceptors.response.use(
            response => {
                let data = response.data;
                return data;
            },
            error => {
                let response = error.response;
                let message = response.data.message || error.message;
                Message({
                    type: "error",
                    message,
                    duration: 2500,
                    onClose: () => {
                        if (response.status === 401) {
                            window.location.href = "/#/login";
                        }
                    }
                });
                return Promise.reject({message});
            }
        );
    }
};
const service = object.merge(privateService, IndividuationService);

export default service;
